'use client'

import { motion } from 'framer-motion'

/**
 * Seedance 2.0 Coming Soon 页面
 * 上线后将 FEATURE_FLAGS.SEEDANCE_COMING_SOON 设置为 false 即可恢复正常页面
 */
export const ComingSoon = () => {
  return (
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden bg-black">
      {/* 顶部光晕效果 - 位于数字2上方 */}
      <div
        className="pointer-events-none absolute left-1/2 top-[15%] h-[300px] w-[400px] -translate-x-1/2 rounded-full blur-[80px]"
        style={{
          background: 'radial-gradient(circle, rgba(180, 140, 255, 0.35) 0%, rgba(120, 80, 200, 0.15) 50%, transparent 70%)'
        }}
      />

      {/* 主要内容容器 */}
      <div className="relative flex items-center justify-center px-4 w-full">
        {/* 大数字 2 - 作为背景基准 */}
        <motion.div
          animate={{ opacity: 1, scale: 1 }}
          className="pointer-events-none select-none"
          initial={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 1, ease: 'easeOut' }}
          style={{
            fontSize: 'clamp(280px, 45vw, 500px)',
            fontWeight: 900,
            lineHeight: 1,
            background: 'linear-gradient(180deg, rgba(80, 70, 100, 0.5) 0%, rgba(45, 40, 60, 0.25) 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          2
        </motion.div>

        {/* 标题文字 - 绝对定位在数字2的垂直居中位置 */}
        <motion.div
          animate={{ opacity: 1, y: 0 }}
          className="absolute left-1/2 top-1/2 z-20 w-full max-w-[90vw] -translate-x-1/2 -translate-y-1/2 px-4 text-center"
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <h1 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">
            <span
              className="bg-clip-text text-transparent"
              style={{
                background: 'linear-gradient(90deg, #a3e635 0%, #84cc16 100%)',
                WebkitBackgroundClip: 'text'
              }}
            >
              SEEDANCE 2.0
            </span>{' '}
            <span className="text-white/90">COMING SOON</span>
          </h1>
        </motion.div>

        {/* 绿色光线装饰 */}
        <motion.div
          animate={{ opacity: 1 }}
          className="absolute left-1/2 top-1/2 h-[2px] w-40 -translate-x-1/2 translate-y-8"
          initial={{ opacity: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
          style={{
            background: 'linear-gradient(90deg, transparent, rgba(163, 230, 53, 0.6), transparent)'
          }}
        />
      </div>
    </div>
  )
}
